import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c4a01926"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "collectall"
};
var _hoisted_2 = {
  class: "less"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "ptext"
  }, " 暂无数据 ", -1);
});

var _hoisted_4 = [_hoisted_3];
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "colltext"
};
var _hoisted_7 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_Pagination = _resolveComponent("Pagination");

  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_table = _resolveComponent("el-table");

  var _component_Tabs = _resolveComponent("Tabs");

  var _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "学习记录"
  }), _createVNode(_component_Tabs, {
    title: _ctx.title,
    onChangeOther: _ctx.changeOther
  }, {
    content0: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_4, 512), [[_vShow, _ctx.show]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.list, function (item) {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: item,
          class: "collect",
          onClick: function onClick($event) {
            return _ctx.todetail(item);
          }
        }, [_createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.createTime), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.deleteTag(item.content)), 1)], 8, _hoisted_5)), [[_vShow, !_ctx.show]]);
      }), 128)), _createVNode(_component_Pagination, {
        pagesize: 10,
        "total-num": _ctx.data.totalNum,
        onChangPage: _ctx.changPage
      }, null, 8, ["total-num", "onChangPage"])])];
    }),
    content1: _withCtx(function () {
      return [_withDirectives(_createVNode(_component_el_table, {
        "element-loading-text": "拼命加载中",
        data: _ctx.downData.list,
        style: {
          "width": "100%"
        },
        "show-header": false,
        class: "el-table-index"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "title",
            label: "Date",
            width: "500"
          }), _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "Name"
          }), _createVNode(_component_el_table_column, {
            width: "100"
          }, {
            default: _withCtx(function (scoped) {
              return [_createElementVNode("span", {
                class: "search",
                onClick: function onClick($event) {
                  return _ctx.todetail(scoped.row);
                }
              }, " 查看详情 ", 8, _hoisted_7)];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data"]), [[_directive_loading, _ctx.loading]]), _createVNode(_component_Pagination, {
        pagesize: 10,
        "total-num": _ctx.data.totalNum,
        onChangPage: _ctx.changPage
      }, null, 8, ["total-num", "onChangPage"])];
    }),
    _: 1
  }, 8, ["title", "onChangeOther"])], 64);
}